"use client";

import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "@/lib/utils";
import { useIsDark } from "@/hooks/useIsDark";
const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;
const TooltipContent = React.forwardRef<React.ElementRef<typeof TooltipPrimitive.Content>, React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
  hideArrow?: boolean;
}>(({
  className,
  sideOffset = 4,
  hideArrow = false,
  children,
  ...props
}, ref) => {
  const isLightBg = typeof className === "string" && /\bbg-(white|gray-50|gray-100|zinc-50|zinc-100|slate-50)\b/.test(className);

  // In dark mode the tooltip gets a border instead of an arrow — the arrow's
  // notch would break that border, so it's dropped in dark.
  const isDark = useIsDark();
  return <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content ref={ref} sideOffset={sideOffset} className={cn("z-50 rounded-lg bg-zinc-800 px-3 py-1.5 text-xs text-white shadow-xl dark:border dark:border-white/15 animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className)} {...props}>
        {children}
        {!hideArrow && !isLightBg && !isDark && <TooltipPrimitive.Arrow className="fill-zinc-800" />}
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>;
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };